import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_ENDPOINT;

const api = axios.create({
  baseURL: apiUrl + '/api',
});

api.interceptors.request.use((config) => {
  // Skip token handling for public endpoints
  if (config.url.startsWith('/public/')) {
    return config;
  }

  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;

    // Skip refresh token handling for public endpoints
    if (originalConfig.url.startsWith('/public/')) {
      return Promise.reject(err);
    }

    if (err.response?.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      const user = JSON.parse(localStorage.getItem('user'));
      if (!user?.refreshToken) {
        return Promise.reject(err);
      }

      try {
        const res = await axios.post(`${apiUrl}/api/auth/refresh-token`, {
          refreshToken: user.refreshToken,
        });

        const newUser = { ...user, token: res.data.accessToken };
        localStorage.setItem('user', JSON.stringify(newUser));

        api.defaults.headers.common['Authorization'] = `Bearer ${res.data.accessToken}`;
        originalConfig.headers['Authorization'] = `Bearer ${res.data.accessToken}`;

        return api(originalConfig);
      } catch (refreshErr) {
        localStorage.removeItem('user');
        window.location.href = '/';
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(err);
  }
);

export default api;
